export default __webpack_public_path__ + "static/media/loader.319d0af8.gif";